<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Mark Finance Approving Authority</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
        <v-row justify="center" dense>
            <v-col cols="12" sm="3">
            <p><b>Instructor*</b></p>
                <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="instructor"
                :items="instructor_list"
                item-text="name"
                item-value="id"
                label="Instructor"
                outlined
                />
        </v-col>
        </v-row>
          <v-row justify="center" dense v-if="instructor">
             <div v-if="inv_finance_approving_authority_list.length > 0">
                           <v-checkbox v-for="role in inv_finance_approving_authority_list" :key="role.id" v-model="authority" :label="role.name" :value="role.id" color="success"></v-checkbox>
                            <span v-if="authority.length ==0">
                           <v-chip>
                                <v-icon left color="red">mdi-exclamation-thick</v-icon>
                                Please Select Authority
                            </v-chip>
                           </span>
                        </div>
          </v-row>
          <br>
               <v-row justify="center" dense v-if="instructor && authority">
          <v-btn color="warning" @click="saveInventoryFinanceApprovinfAuthority()" :loading="loader" :disabled="authority.length < 1"
            >Add</v-btn
          >
        </v-row>
       </v-card>

     <v-card class="box" v-if="instructor_finance_approving_authority_list!='' ">
     <v-data-table  :headers="headers" :items="instructor_finance_approving_authority_list" :items-per-page="-1">
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Inventory Finance Approving Authority List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
         <template v-slot:[`item.isactive`]="{ item }">
                 <v-switch v-model="item.isactive"  @change="toggleIsactive(item)"></v-switch>
      </template>
       <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="deleteInventoryMaterial(item)"
                >mdi-trash-can</v-icon
              >
            </v-avatar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="editDetail(item)"
                >mdi-pencil</v-icon
              >
            </v-avatar>
          </template>
     </v-data-table>
 </v-card>

         <v-dialog
        v-model="dialog_edit"
        persistent
        scrollable="false"
        max-width="1200px"
        transition="dialog-bottom-transition"
      >
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Finance Approving Authority</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center" dense>
            <v-col cols="12" sm="5">
            <p><b>Instructor</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="editedItem.instructor"
              :items="instructor_list"
              item-text="name"
              item-value="id"
              label="Instructor"
              outlined
            />
          </v-col>
            </v-row>
             <v-row justify="center" dense>
                <v-checkbox v-for="role in inv_finance_approving_authority_list" :key="role.id" v-model="editedItem.authority" :label="role.name" :value="role.id" color="success"></v-checkbox>
          </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveUpdateInventoryFinanceApprovinfAuthority()"
              >Update</v-btn
            >
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      name:"",
      code:"",
      instructor_list:[],instructor:"",
      inv_finance_approving_authority_list:[],authority:[],
      instructor_finance_approving_authority_list:[],
      headers:[
      { text: "Instructor", value: "instructor" },
      { text: "Authority", value: "invfinanceapprovingauthority" },
      { text: "Isactive", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
      ],
    dialog_edit: false,
    editedItem: {
      id: "",authority:[],instructor:""
    },
  }),
   methods: {
      clearData(){
        this.instructor="",this.authority=""
      },
      async saveUpdateInventoryFinanceApprovinfAuthority(){
       this.overlay = true;
       this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveUpdateInventoryFinanceApprovinfAuthority", this.editedItem);
          if (res.data.flag == "YES") {
            this.instructor_finance_approving_authority_list=res.data.instructor_finance_approving_authority_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar  
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
         this.dialog_edit = false;
      }
    },
    editDetail(item) {
      this.editedItem.id = item.id;
      this.editedItem.instructor = item.instructor_id;
      this.editedItem.authority = item.invfinanceapprovingauthority_id;
      this.dialog_edit = true;
    },
    async saveInventoryFinanceApprovinfAuthority(){
        const data = {
        instructor:this.instructor,
        authority:this.authority,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveInventoryFinanceApprovinfAuthority", data);
          if (res.data.flag == "YES") {
            this.instructor_finance_approving_authority_list=res.data.instructor_finance_approving_authority_list
            this.showSnackbar("green", "Saved Successfully"); // show snackbar   
            this.clearData();
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async toggleIsactive(item){
        const data = {
            id: item.id,
            isactive: item.isactive,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/toggleIsactiveInventoryFinanceApprovinfAuthority", data);
          if (res.data.flag == "YES") {
            this.instructor_finance_approving_authority_list=res.data.instructor_finance_approving_authority_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar    
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async deleteInventoryMaterial(item){
       if (!confirm("Are You Sure You Want To Delete This Item?"))
        return;
        const data = {
            id: item.id,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/deleteInventoryFinanceApprovinfAuthority", data);
          if (res.data.flag == "YES") {
            this.instructor_finance_approving_authority_list=res.data.instructor_finance_approving_authority_list
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
    async onLoad() {
      try {
          const res = await axios.post("/Inventory/getInventoryFinanceApprovinfAuthorityList");
          if (res.data.flag == "YES") {
            this.instructor_list=res.data.instructor_list
            this.inv_finance_approving_authority_list=res.data.inv_finance_approving_authority_list
            this.instructor_finance_approving_authority_list=res.data.instructor_finance_approving_authority_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>